// extracted by mini-css-extract-plugin
export default {"sectionHeader":"style_sectionHeader__DJGQT","title":"style_title__89I2t","actions":"style_actions__17twO"};